var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSegment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "segment_svg__segment_svg__Canvas",
    transform: "translate(7961 -2578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "segment_svg__segment_svg__Fill_1_+_Fill_3_+_Fill_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "segment_svg__segment_svg__Fill_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#segment_svg__segment_svg__path0_fill",
    transform: "translate(-7955.83 2578.97)",
    fill: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "segment_svg__segment_svg__Fill_3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#segment_svg__segment_svg__path1_fill",
    transform: "translate(-7961 2579.59)",
    fill: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "segment_svg__segment_svg__Fill_6"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#segment_svg__segment_svg__path2_fill",
    transform: "translate(-7959.64 2585.24)",
    fill: "#B3B3B3"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "segment_svg__segment_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 2.40201 6.63519C 0.753881 6.23899 -0.289334 4.44963 0.0712626 2.63878C 0.432419 0.827919 2.06098 -0.318302 3.70854 0.0785137C 5.35667 0.474716 6.39988 2.26407 6.03928 4.07432C 5.67869 5.88517 4.05013 7.03139 2.40201 6.63519Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "segment_svg__segment_svg__path1_fill",
    fillRule: "evenodd",
    d: "M 1.38563 3.82782C 0.43522 3.59931 -0.166893 2.56673 0.041079 1.52247C 0.24961 0.477607 1.18884 -0.183344 2.13925 0.0451635C 3.09022 0.273671 3.69233 1.30625 3.4838 2.35051C 3.27583 3.39537 2.33604 4.05632 1.38563 3.82782Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "segment_svg__segment_svg__path2_fill",
    fillRule: "evenodd",
    d: "M 1.66288 4.59352C 0.521832 4.31894 -0.200481 3.08058 0.0494216 1.82686C 0.299324 0.573758 1.42696 -0.219875 2.56745 0.0540882C 3.7085 0.328665 4.43082 1.56764 4.18091 2.82074C 3.93101 4.07446 2.80394 4.86809 1.66288 4.59352Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegment);
export default __webpack_public_path__ + "static/media/segment.6f2bd40968f847971eb7ca4666c4e302.svg";
export { ForwardRef as ReactComponent };